import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Select } from './Select.js';
import '@hh.ru/magritte-common-keyboard';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-input/BaseInput';
import './SelectBottomSheet.js';
import 'classnames';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-action-bar';
import '@hh.ru/magritte-ui-bottom-sheet';
import '@hh.ru/magritte-ui-button';
import '@hh.ru/magritte-ui-cell';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-input';
import '@hh.ru/magritte-ui-loader';
import '@hh.ru/magritte-ui-navigation-bar';
import './SelectError.js';
import '@hh.ru/magritte-ui-icon/variants/icon';
import '@hh.ru/magritte-ui-spacing';
import '@hh.ru/magritte-ui-title';
import '@hh.ru/magritte-ui-typography';
import './SelectOption.js';
import '@hh.ru/magritte-ui-checkable-card/CheckableCardElement';
import '@hh.ru/magritte-ui-checkbox-radio';
import './getChecked.js';
import './isArraysEquals.js';
import './SelectDrop.js';
import '@hh.ru/magritte-ui-drop';
import './useSelectOptionsList.js';
import './useSelectSearch.js';
import '@hh.ru/magritte-common-data-provider';
import './useSelectState.js';
import '@hh.ru/magritte-ui-trigger';

const UncontrolledSelect = ({ name, onChange, ...props }) => {
    const { value } = props;
    const [controlledValue, setValue] = useState(value);
    return (jsxs(Fragment, { children: [jsx(Select, { ...props, onChange: (values) => {
                    setValue(values);
                    onChange?.(values);
                }, value: controlledValue, name: name }), Array.isArray(controlledValue) ? (controlledValue.map((value) => (jsx("input", { type: "hidden", name: name, value: value.value }, value.value)))) : (jsx("input", { type: "hidden", name: name, value: controlledValue?.value }))] }));
};
UncontrolledSelect.displayName = 'UncontrolledSelect';

export { UncontrolledSelect };
//# sourceMappingURL=UncontrolledSelect.js.map
